<template>
  <div data-qa="payment_info">
    <v-expand-transition>
      <div v-if="clubDataStore.isClubSelectTypePaymentVisible">
        <PaymentClub
          ref="paymentClubRef"
          :full-price="doctorDataStore.selectedWorkplace.priceList?.price"
          :club-offer-data="clubDataStore.offerData/* @ts-ignore */"
        >
          <template #default="{ isClubEnabled }">
            <div class="d-flex flex-column gr-3">
              <AppointmentSubmitV2
                :option-price="clubDataStore.offerData?.couponPrice"
                :card-price="clubDataStore.offerData?.cardPrice"
                :is-club-enabled="isClubEnabled"
                @click:appointment="handleAppointment"
              />
              <PersonalData />
            </div>
          </template>
        </PaymentClub>
      </div>
    </v-expand-transition>

    <div
      v-if="!clubDataStore.isClubSelectTypePaymentVisible"
      class="content d-flex flex-column gr-3"
    >
      <v-expand-transition>
        <div
          v-if="doctorDataStore.isWorkplaceSelected
            && (!appointmentDataStore.isAnyTelemed || calendarDataStore.isCalendarDateSelected)"
          :key="doctorDataStore.selectedWorkplace.id"
        >
          <PaymentTerms class="mb-3" />
        </div>
      </v-expand-transition>
      <AppointmentSubmitV2
        @click:appointment="handleAppointment"
      />
      <PersonalData />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import useYandexGoals from 'src/composables/useYandexGoals'
import {
  useAppointmentDataStore,
  useCalendarDataStore,
  useClubDataStore,
  useDoctorDataStore,
  useGlobalDataStore,
  useYandexGoalsStore,
} from 'www/vue_components/common/AppointmentPage/stores'
import AppointmentSubmitV2 from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/AppointmentSubmitV2.vue'
import PaymentClub from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentClub/PaymentClub.vue'
import PersonalData from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PersonalData.vue'
import PaymentTerms from 'src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentTerms.vue'
import { APPOINTMENT_ERRORS } from 'www/vue_components/common/AppointmentPage/constants'
import { APPOINTMENT_YANDEX_GOALS } from 'src/components/pages/appointment/vrach/new/constants'
import useFamilyProfilesStore from 'www/vue_components/common/FamilyProfiles/stores/useFamilyProfilesStore'
import useLpuDataStore from 'www/vue_components/common/AppointmentPage/stores/useLpuDataStore'

const appointmentDataStore = useAppointmentDataStore()
const calendarDataStore = useCalendarDataStore()
const clubDataStore = useClubDataStore()
const doctorDataStore = useDoctorDataStore()
const globalDataStore = useGlobalDataStore()
const yandexGoalsStore = useYandexGoalsStore()
const familyProfilesStore = useFamilyProfilesStore()
const lpuDataStore = useLpuDataStore()

const paymentClubRef = ref()

const { sendYaGoal } = useYandexGoals()

function handleAppointment() {
  if (familyProfilesStore.isUnderagePatient && lpuDataStore.isTelemedMedical) {
    return
  }

  if (paymentClubRef.value) {
    const invalidEl = paymentClubRef.value.validate()

    if (invalidEl !== true) {
      invalidEl.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })

      return
    }
  }

  if (
    appointmentDataStore.appointmentObjectTypes.isDoctor
        && calendarDataStore.isEmptyCalendarList
        && appointmentDataStore.appointmentRegistrationTypes.isDirect
        && !calendarDataStore.editableCalendar.selectedDate.isSlotFixed
  ) {
    globalDataStore.updateErrorData({
      isEnabled: true,
      isPersistent: true,
      isDialogRender: true,
      ...APPOINTMENT_ERRORS.appointmentDoctorOnlineNotWork,
    })

    return
  }

  if (appointmentDataStore.isAppointmentByReferral) {
    sendYaGoal('appointment__clickAppointmentByReferral')
  }

  yandexGoalsStore.sendYaGoal({
    name: APPOINTMENT_YANDEX_GOALS.clickAppointmentDirect,
    formType: 'anyDirect',
    objectType: 'doctor',
  })
  yandexGoalsStore.sendYaGoal({
    name: APPOINTMENT_YANDEX_GOALS.serviceClickAppointmentDirect,
    formType: 'direct',
    objectType: 'service',
  })

  appointmentDataStore.confirmAppointment()
}
</script>

<style lang="scss" scoped>
.content > :deep(.expand-transition-leave-active),
.content > :deep(.expand-transition-enter) {
  margin-bottom: -12px; // компенсирует gr-3
}
</style>
